import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Space, Stack, useColorMode } from '@tonic-ui/react';

import styles from './error-handler.module.css';
import { ExternalLink } from '../../components/external-link';
import { isGovCloudRegion } from '../../utils/helpers';

type ErrorHandler = {
  title?: string;
  message?: string;
  children?: React.ReactNode;
  id: string;
};

const ErrorHandler = ({ title, message, id, children }: ErrorHandler): JSX.Element => {
  const { t } = useTranslation();
  const [colorMode] = useColorMode() as string;
  // set style for dark mode
  const colorModeClass = (colorMode === 'dark' ? styles.dark : '') as string;

  const errorTitle = title || t('errorMessaging.title');
  const errorMessage = message || t('errorMessaging.message');
  return (
    <Stack
      spacing="5x"
      className={styles.error_page as string}
      role="alert"
      data-id={id}
      data-telemetry-id={id}
    >
      <Box className={styles.error_icon as string} />
      <Box className={`${styles.error_title} ${colorModeClass}`}>{errorTitle}</Box>
      <Box margin="auto" className={`${styles.error_message} ${colorModeClass}`}>
        {children ?? (
          <>
            {errorMessage}
            <Space width="5px" />
            <ExternalLink
              href={t(`errorMessaging.${isGovCloudRegion ? 'supportLinkGov' : 'supportLink'}`)}
              showIcon={false}
            >
              {t('errorMessaging.linkedContent')}
            </ExternalLink>
          </>
        )}
      </Box>
    </Stack>
  );
};

ErrorHandler.displayName = 'ErrorHandler';

export default ErrorHandler;
